import React from 'react'
import { Formik } from 'formik'
import {
	SearchSection,
	EditSearchSection,
	FilterGrid,
	SearchButtonsContainer,
	SearchInfo,
	SearchDiv,
	SearchHeader
} from './styled'
import { Edit, SearchIcon } from '../../assets/icons'
import { Button } from '../ui/button'
import { Title, Text2 } from '../ui/text'
import theme from '../../styled/theme'
import { validateDateAndTimeRanges } from '../../pages/private/Appointments/schemas/searchMapSchemas'
import AppointmentFilterFields from './AppointmentFilterFields'

const SearchSectionEditor = ({
	isEditingSearch,
	setIsEditingSearch,
	isMobile,
	specialtyName,
	selectedFiltersText,
	formData,
	multipleFiltersFormData,
	onShowFiltersModal,
	onSearchSubmit,
	onMultipleFilterSubmit,
	filterFieldsProps,
	multipleFilterFieldsProps = {},
	isMultTurns
}) => {
	return (
		<>
			{!isEditingSearch && !isMultTurns ? (
				<SearchSection>
					<SearchHeader>
						<SearchDiv>
							<SearchIcon />
							<SearchInfo>
								<Text2 as="span" fontWeight="bold" color={theme.colors.text.titleText}>
									{specialtyName}
								</Text2>
								<Text2 as="span" color={theme.colors.text.descriptionText}>
									{selectedFiltersText}
								</Text2>
							</SearchInfo>
						</SearchDiv>
						<Button
							$variant="link"
							label={isMobile ? 'Editar' : 'Editar búsqueda'}
							iconRight={<Edit />}
							style={{ marginLeft: 'auto' }}
							onClick={() => {
								if (window.innerWidth <= 768) {
									onShowFiltersModal()
								} else {
									setIsEditingSearch(true)
								}
							}}
						/>
					</SearchHeader>
				</SearchSection>
			) : isEditingSearch && !isMultTurns ? (
				<SearchSection>
					<Formik
						initialValues={formData}
						enableReinitialize={true}
						validate={validateDateAndTimeRanges}
						onSubmit={(values, { setErrors }) => {
							const validationErrors = validateDateAndTimeRanges(values)
							if (Object.keys(validationErrors).length > 0) {
								setErrors(validationErrors)
								return
							}
							onSearchSubmit(values, () => setIsEditingSearch(false))
						}}
					>
						{({ values, handleSubmit, setFieldValue, errors }) => (
							<EditSearchSection>
								<Title size="18px" margin="0 0 20px 0" color={theme.colors.text.titleText}>
									{isMobile ? 'Editar' : 'Editar búsqueda'}
								</Title>
								<FilterGrid>
									<AppointmentFilterFields
										values={values}
										setFieldValue={setFieldValue}
										errors={errors}
										{...filterFieldsProps}
									/>
								</FilterGrid>
								<SearchButtonsContainer>
									<Button
										onClick={handleSubmit}
										type="submit"
										label={'Buscar'}
										size={'small'}
										disabled={!values.speciality || !(values.clinic && values.clinic.length > 0)}
									/>
									<Button
										$variant="secondary"
										size={'small'}
										label={'Cancelar'}
										onClick={() => {
											setIsEditingSearch(false)
										}}
									/>
								</SearchButtonsContainer>
							</EditSearchSection>
						)}
					</Formik>
				</SearchSection>
			) : isEditingSearch && isMultTurns ? (
				<SearchSection>
					<Formik
						initialValues={multipleFiltersFormData}
						enableReinitialize={true}
						validate={validateDateAndTimeRanges}
						onSubmit={(values, { setErrors }) => {
							const validationErrors = validateDateAndTimeRanges(values)
							if (Object.keys(validationErrors).length > 0) {
								setErrors(validationErrors)
								return
							}
							onMultipleFilterSubmit(values, () => setIsEditingSearch(false))
						}}
					>
						{({ values, handleSubmit, setFieldValue, errors }) => (
							<EditSearchSection>
								<Title size="18px" margin="0 0 20px 0" color={theme.colors.text.titleText}>
									{isMobile ? 'Editar' : 'Editar búsqueda'}
								</Title>
								<FilterGrid>
									<AppointmentFilterFields
										values={values}
										setFieldValue={setFieldValue}
										errors={errors}
										hideSpeciality
										{...multipleFilterFieldsProps}
									/>
								</FilterGrid>
								<SearchButtonsContainer>
									<Button
										onClick={handleSubmit}
										type="submit"
										label={'Buscar'}
										size={'small'}
									/>
									<Button
										$variant="secondary"
										size={'small'}
										label={'Cancelar'}
										onClick={() => {
											setIsEditingSearch(false)
										}}
									/>
								</SearchButtonsContainer>
							</EditSearchSection>
						)}
					</Formik>
				</SearchSection>
			) : null}
		</>
	)
}

export default SearchSectionEditor
